import { api, ccmApi } from './api';

export async function getKioskSettings() {
  const s = await ccmApi.getSettings();
  return s && typeof s === 'object' ? s : {};
}
export async function saveKioskSetting(key, value) {
  return await ccmApi.saveSettings({ [key]: value });
}
export async function listPhysicians() { return await api.get('/data/kiosk/physicians'); }
export async function listPractices()  { return await api.get('/data/kiosk/practices'); }
export async function listDevices() {
  const res = await api.get('/data/kiosk-devices');
  return res.devices || [];
}
export async function mintDevice(label) { return await api.post('/data/kiosk-devices', { label }); }
export async function revokeDevice(id) { return await api.delete(`/data/kiosk-devices/${id}`); }
export async function syncPayers() { return await api.post('/data/kiosk/sync-payers', {}); }
export async function listPayers() {
  const res = await api.get('/data/kiosk/payers');
  return res.payers || [];
}
// Staff-validated carrier matches (card name / payer ID → Elation company) —
// checked before fuzzy matching, survive payer re-syncs.
export async function listCarrierOverrides() {
  const res = await api.get('/data/kiosk/carrier-overrides');
  return res.overrides || [];
}
export async function addCarrierOverride({ carrierName, payerId, elationCompanyId }) {
  return await api.post('/data/kiosk/carrier-overrides', { carrierName, payerId, elationCompanyId });
}
export async function deleteCarrierOverride(id) {
  return await api.delete(`/data/kiosk/carrier-overrides/${id}`);
}
